import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {forgetPassword} from '../core/_requests'
import {Link} from 'react-router-dom'

const initialValues = {email: ''}

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)

  const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string().trim().email('Enter a valid email').required('Email is required'),
  })
  const [success, setSuccess] = useState(false)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, {resetForm}) => {
      setLoading(true)
      try {
        await forgetPassword(values)
        resetForm()
        setSuccess(true)
      } catch (err) {
        console.error(err)
      } finally {
        setLoading(false)
      }
    },
  })

  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          <h1 className='text-dark mb-3'>Forget Password</h1>
        </div>
        {success ? (
          <div className='d-flex flex-wrap justify-content-center'>
            A password reset link has been sent to your email.
            <div>Check your inbox and spam folder.</div>
          </div>
        ) : (
          <>
            <div className='fv-row mb-5'>
              <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label>
              <input
                type='email'
                placeholder=''
                autoComplete='off'
                {...formik.getFieldProps('email')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {'is-invalid': formik.touched.email && formik.errors.email},
                  {'is-valid': formik.touched.email && !formik.errors.email}
                )}
                disabled={loading}
              />
              {formik.touched.email && formik.errors.email && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'></div>
                </div>
              )}
            </div>

            <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
              <button
                type='submit'
                id='kt_password_reset_submit'
                className='btn btn-lg btn-primary fw-bolder me-4'
                disabled={formik.isSubmitting || !formik.isValid}
              >
                {!formik.isSubmitting ? (
                  <span className='indicator-label'>Submit</span>
                ) : (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </>
        )}
        <div className='my-5'>
          <Link to='/auth/login'>
            <i className='bi bi-arrow-left me-2 text-primary'></i>
            Back to login
          </Link>
        </div>
      </form>
    </>
  )
}
